import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
export type ListRolesOrganisationFragment = { __typename?: 'Organisation', roles: { __typename?: 'CustomRolesConnection', nodes: Array<{ __typename?: 'CustomRole', id: string, name: string, description?: string | null }> }, environments: { __typename?: 'EnvironmentsConnection', nodes: Array<{ __typename?: 'Environment', id: string, name: string, active: boolean }> } };

export const ListRolesOrganisationFragmentDoc = gql`
    fragment ListRolesOrganisation on Organisation {
  roles: customRoles {
    nodes {
      id
      name
      description
    }
  }
  environments {
    nodes {
      id
      name
      active
    }
  }
}
    `;